import { ICON_NAMES } from "@/components/ServiceIcon";

export const ENTITIES = {
  packages: {
    title: "Paketler",
    singular: "Paket",
    nameOf: (i) => `${i.name} (${i.speed} Mbps)`,
    defaults: { name: "", speed: 100, price: 0, features: {}, popular: false, active: true, order: 1 },
    fields: [
      { key: "name", label: "Paket Adı", type: "text" },
      { key: "speed", label: "Hız (Mbps)", type: "number" },
      { key: "price", label: "Aylık Fiyat (₺)", type: "number" },
      { key: "features", label: "Özellikler (her satıra bir özellik)", type: "ml-lines" },
      { key: "popular", label: "Öne Çıkan (En Popüler)", type: "boolean" },
      { key: "order", label: "Sıra", type: "number" },
      { key: "active", label: "Aktif", type: "boolean" },
    ],
  },
  services: {
    title: "Hizmetler",
    singular: "Hizmet",
    nameOf: (i) => i.title?.tr || "-",
    defaults: { title: {}, description: {}, icon: "Zap", active: true, order: 1 },
    fields: [
      { key: "title", label: "Başlık", type: "ml-text" },
      { key: "description", label: "Açıklama", type: "ml-textarea" },
      { key: "icon", label: "İkon", type: "select", options: ICON_NAMES },
      { key: "order", label: "Sıra", type: "number" },
      { key: "active", label: "Aktif", type: "boolean" },
    ],
  },
  campaigns: {
    title: "Kampanyalar",
    singular: "Kampanya",
    nameOf: (i) => i.title?.tr || "-",
    defaults: { badge: {}, title: {}, description: {}, image: "", active: true, order: 1 },
    fields: [
      { key: "badge", label: "Rozet (kısa etiket)", type: "ml-text" },
      { key: "title", label: "Başlık", type: "ml-text" },
      { key: "description", label: "Açıklama", type: "ml-textarea" },
      { key: "image", label: "Görsel URL", type: "text" },
      { key: "order", label: "Sıra", type: "number" },
      { key: "active", label: "Aktif", type: "boolean" },
    ],
  },
  faqs: {
    title: "Sıkça Sorulan Sorular",
    singular: "Soru",
    nameOf: (i) => i.question?.tr || "-",
    defaults: { question: {}, answer: {}, active: true, order: 1 },
    fields: [
      { key: "question", label: "Soru", type: "ml-text" },
      { key: "answer", label: "Cevap", type: "ml-textarea" },
      { key: "order", label: "Sıra", type: "number" },
      { key: "active", label: "Aktif", type: "boolean" },
    ],
  },
  posts: {
    title: "Blog Yazıları",
    singular: "Yazı",
    nameOf: (i) => i.title?.tr || "-",
    defaults: { title: {}, slug: "", excerpt: {}, content: {}, image: "", published: true },
    fields: [
      { key: "title", label: "Başlık", type: "ml-text" },
      { key: "slug", label: "URL (slug, örn: fiber-internet-nedir)", type: "text" },
      { key: "excerpt", label: "Özet", type: "ml-textarea" },
      { key: "content", label: "İçerik (paragraflar arasına boş satır koyun)", type: "ml-textarea", rows: 10 },
      { key: "image", label: "Kapak Görseli URL", type: "text" },
      { key: "published", label: "Yayında", type: "boolean" },
    ],
  },
};
